import React from 'react';
import { Provider } from 'react-redux';
import store, { history } from 'client/store';
import ErrorBoundary from 'common/components/ErrorBoundary';
import Debugger from 'common/components/Debugger';

import App from './App';

const Root = () => {
	return (
		<Provider store={store}>
			<ErrorBoundary>
				<App history={history} />
				<Debugger />
			</ErrorBoundary>
		</Provider>
	);
};

export default Root;
